import ProceduresList from './ProceduresList.container';

export default ProceduresList;
